import React from 'react';
import PropTypes from 'prop-types';
import { InputController } from "../InputController";
export var Component = function Component(_ref) {
  var autoComplete = _ref.autoComplete,
      error = _ref.error,
      isValid = _ref.isValid,
      label = _ref.label,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      value = _ref.value,
      maxCharacters = _ref.maxCharacters;
  return React.createElement(InputController, {
    error: error,
    isValid: isValid,
    label: label,
    name: name,
    onChange: onChange,
    value: value
  }, React.createElement("textarea", {
    autoComplete: autoComplete,
    maxLength: maxCharacters,
    onBlur: onBlur,
    placeholder: label,
    rows: "8"
  }));
};
Component.displayName = 'TextArea';
Component.defaultProps = {
  autoComplete: null,
  error: false,
  isValid: false,
  label: '',
  maxCharacters: null,
  name: '',
  onBlur: Function.prototype,
  onChange: Function.prototype,
  value: ''
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  autoComplete: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  isValid: PropTypes.bool,
  label: PropTypes.string,
  maxCharacters: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string
} : {};